import { render, staticRenderFns } from "./nav_bar.vue?vue&type=template&id=09f48adb&scoped=true"
import script from "./nav_bar.vue?vue&type=script&lang=js"
export * from "./nav_bar.vue?vue&type=script&lang=js"
import style0 from "./nav_bar.vue?vue&type=style&index=0&id=09f48adb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f48adb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f48adb')) {
      api.createRecord('09f48adb', component.options)
    } else {
      api.reload('09f48adb', component.options)
    }
    module.hot.accept("./nav_bar.vue?vue&type=template&id=09f48adb&scoped=true", function () {
      api.rerender('09f48adb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/nav_bar.vue"
export default component.exports